import { useEffect, useMemo, useRef, useState } from 'react';

export default function MultiSelectDropdown({
  label,
  options = [],
  value,
  onChange,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = useMemo(
    () => (value instanceof Set ? value : new Set(value || [])),
    [value],
  );

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const toggle = (v) => {
    if (disabled) return;
    const next = new Set(selected);
    if (next.has(v)) next.delete(v);
    else next.add(v);
    onChange(next);
  };

  const clear = () => { if (!disabled) onChange(new Set()); };

  const triggerLabel = selected.size === 0 ? label : `${label} (${selected.size})`;

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="btn small"
        onClick={() => setOpen((o) => !o)}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {triggerLabel} ▾
      </button>
      {open && (
        <div
          role="listbox"
          aria-multiselectable="true"
          className="topbar-menu"
          style={{ minWidth: 200, maxHeight: 320, overflowY: 'auto' }}
        >
          {options.map((o) => {
            const on = selected.has(o.value);
            return (
              <label key={o.value} className="topbar-menu-item" style={{ cursor: 'pointer' }}>
                <input type="checkbox" checked={on} onChange={() => toggle(o.value)} />
                {o.swatch && (
                  <span
                    aria-hidden
                    style={{ width: 10, height: 10, borderRadius: 2, background: o.swatch, display: 'inline-block', flexShrink: 0 }}
                  />
                )}
                {o.icon ? `${o.icon} ` : ''}{o.label}
              </label>
            );
          })}
          {selected.size > 0 && (
            <>
              <div className="topbar-menu-sep" />
              <button type="button" className="topbar-menu-item" onClick={clear}>
                Clear {label.toLowerCase()}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
